import { render } from "./index.vue?vue&type=template&id=2efc5549&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2efc5549&lang=scss&scoped=true"

import exportComponent from "D:\\project\\dongmeng\\meeting-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efc5549"]])

export default __exports__